import { useEffect } from "preact/compat";
import { invoke } from "$store/runtime.ts";

interface Props {
  formId: string;
}

function setup(formId: string) {
  const form = document.getElementById(formId) as HTMLFormElement | null;

  if (!form) {
    console.warn(
      "Missing necessary form attributes. It will not work as intended. Necessary elements:",
      { form, formId },
    );

    return;
  }

  const onSubmit = async (event: SubmitEvent) => {
    event.preventDefault();

    const formData = new FormData(form);
    const data = Object.fromEntries(formData) as {
      [key: string]: string | boolean;
    };

    for (const [key, value] of Object.entries(data)) {
      if (value === "on") {
        data[key] = true;
      }
    }

    const { success, errors } = await invoke["site"]
      .actions.contact(data);

    if (errors && Object.keys(errors).length) {
      for (const [key, value] of Object.entries(errors)) {
        const label = form.querySelector(`[for=${key}]`);
        const container = label?.parentElement;

        if (container?.hasAttribute("data-error")) {
          return;
        }

        container?.setAttribute("data-error", "true");

        const input = container
          ?.querySelector<HTMLInputElement>(`[name=${key}]`);

        if (input?.type !== "checkbox") {
          const errorMessage = document.createElement("label");
          errorMessage.className = "text-[#DC5959] font-bold";
          errorMessage.htmlFor = input?.id ?? key;
          errorMessage.textContent = value;

          container?.append(errorMessage);

          input?.addEventListener(
            "input",
            () => errorMessage.remove(),
            { once: true },
          );
        }

        input?.addEventListener(
          "input",
          () => label?.parentElement?.removeAttribute("data-error"),
          { once: true },
        );
      }

      return;
    }

    if (success) {
      form.setAttribute("data-success", "true");
      form.reset();

      setTimeout(() => {
        form.removeAttribute("data-success");
      }, 3000);
    } else {
      const errorMessage = document.createElement("label");
      errorMessage.className =
        "w-11/12 p-2 mx-auto border border-[#DC5959] text-[#DC5959] bg-red-200 text-center font-bold absolute top-[20%] left-0 right-0";
      errorMessage.textContent =
        "Ocorreu um erro inesperado ao enviar a mensagem. Tente novamente.";

      form?.append(errorMessage);

      setTimeout(() => {
        errorMessage.remove();
      }, 5000);
    }
  };

  form.addEventListener("submit", onSubmit);

  return () => {
    form.removeEventListener("submit", onSubmit);
  };
}

export default function ContactJS({ formId }: Props) {
  useEffect(() => {
    setup(formId);
  }, [formId]);

  return null;
}
